const Advertising = (props) => {
    return (
        <>
        {/*
            <hr className="c_w-100 c_m-0" />

            <div className="c_grid-ad c_px-5 c_600-px-0">
                <div>
                    <img src="/public/src/img/bg-cover/png/telegram_3.png" alt="Unisciti al nostro canale" />
                </div>
                <div>
                    <img src="/public/src/img/bg-cover/png/ad_1.png" alt="Partecipa all'evento" />
                </div>
                <div>
                    <img src="/public/src/img/bg-cover/png/ad_2.png" alt="Acquista il libro" />
                </div>
            </div>

            {props.lastHR &&
                <hr className="c_w-100 c_m-0" />
            }
        */}
        </>
    );
};
